module.exports = __webpack_public_path__ + "static/media/主页面[新]_01.eea52e28.jpg";